import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getCompanyDetailSucceed, requestFailure } from '../actions'

export function* getCompanyDetailSaga(
  companyApi: {
    getCompanyDetail: (...args: any[]) => any
  },
  { payload: companyId }: { payload: string }
) {
  try {
    const { data } = yield call(companyApi.getCompanyDetail, companyId)
    yield put(getCompanyDetailSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
